<ion-content class="ion-no-padding">
  <div class="lead-form model-container">
    <ion-header class="model-header ion-no-border ion-padding-horizontal sticky-top bg-white">
      <ion-toolbar class="header-first-toolbar">
        <ion-title class="text-start ion-no-padding title-blue">
          <span>Add Hotel</span>
        </ion-title>
        <ion-buttons slot="end" class="ion-no-margin">
          <ion-button class="filled-blue-btn" (click)="onSubmit(true)" [disabled]="!formDataModified()">Save &
            New</ion-button>
          <ion-button class="filled-blue-btn" type="submit" (click)="onSubmit()"
            [disabled]="!formDataModified()">Save</ion-button>
          <ion-button class="unfilled-gray-btn" (click)="closeModal()">
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <div class="model-content">
      <div class="dashed-line"></div>
      <div class="form-container">
        <form [formGroup]="hotelPricingForm">
          <div class="invoice-form-container">
            <div>
              <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Hotel Details </ion-title>
            </div>
            <div class="form-containesr ion-padding-horizontal toggle-visibility" formGroupName="hotelDetails">
              <!-- hotels row -->
              <div class="row">
                <div class="col-3">
                  <div class="input-container">
                    <label for="state" class="label">Location *</label>
                    <div
                      [ngClass]="{ 'invalid-input': hotelPricingForm.get('hotelDetails.location')?.invalid && hotelPricingForm.get('hotelDetails.location')?.touched }">
                      <app-locations-autocomplete formControlName="location"></app-locations-autocomplete>
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="input-container">
                    <label for="" class="label">Hotel Name*</label>
                    <div
                      [ngClass]="{ 'invalid-input': hotelPricingForm.get('hotelDetails.hotelName')?.invalid && hotelPricingForm.get('hotelDetails.hotelName')?.touched }">
                      <input class="input-text input" type="text" placeholder="Enter Hotel Name"
                        formControlName="hotelName">
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="input-container">
                    <label for="" class="label">Hotel Category*</label>
                    <div
                      [ngClass]="{ 'invalid-input': hotelPricingForm.get('hotelDetails.hotelCategory')?.invalid && hotelPricingForm.get('hotelDetails.hotelCategory')?.touched }">
                      <select class="input" formControlName="hotelCategory">
                        <option value="" hidden>select</option>
                        <option *ngFor="let item of accommodationType" [value]="item.name">{{item.name}}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="input-container">
                    <label for class="label">Hotel Website</label>
                    <div
                      [ngClass]="{ 'invalid-input': hotelPricingForm.get('hotelDetails.hotelWebsite')?.invalid && hotelPricingForm.get('hotelDetails.hotelWebsite')?.touched }">
                      <input type="text" class="input" placeholder="www.yourdomain.com"
                        formControlName="hotelWebsite" />
                    </div>
                  </div>
                </div>
              </div>
              <!-- addresss fields -->
              <div class="row">
                <div class="col-6">
                  <div class="input-container">
                    <label for class="label">Address Line 1 *</label>
                    <div
                      [ngClass]="{ 'invalid-input': hotelPricingForm.get('hotelDetails.address1')?.invalid && hotelPricingForm.get('hotelDetails.address1')?.touched }">
                      <input type="text" class="input input-text" placeholder="Address1" formControlName="address1" />
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <div class="input-container">
                    <label for class="label">Address Line 2</label>
                    <div
                      [ngClass]="{ 'invalid-input': hotelPricingForm.get('hotelDetails.address2')?.invalid && hotelPricingForm.get('hotelDetails.address2')?.touched }">
                      <input type="text" class="input input-text" placeholder="Address2" formControlName="address2" />
                    </div>
                  </div>
                </div>
              </div>
              <!-- address details  -->
              <div class="row">
                <div class="col-12">
                  <app-address-fields formControlName="groupedAddress"></app-address-fields>
                </div>
              </div>
              <!-- names -->
              <div class="row">
                <div class="col-6">
                  <div class="input-container">
                    <label for="" class="label">First Name*</label>
                    <div
                      [ngClass]="{ 'invalid-input': hotelPricingForm.get('hotelDetails.firstName')?.invalid && hotelPricingForm.get('hotelDetails.firstName')?.touched }">
                      <input class="input" type="text" placeholder="First Name" formControlName="firstName">
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <div class="input-container">
                    <label for="" class="label">Last Name</label>
                    <div
                      [ngClass]="{ 'invalid-input': hotelPricingForm.get('hotelDetails.lastName')?.invalid && hotelPricingForm.get('hotelDetails.lastName')?.touched }">
                      <input class="input" type="text" placeholder="Last Name" formControlName="lastName">
                    </div>
                  </div>
                </div>

              </div>
              <!-- email and number -->
              <div class="row">
                <div class="col-6">
                  <div class="input-container">
                    <label for class="label">Contact Phone Number</label>
                    <div
                      [ngClass]="{ 'invalid-input': hotelPricingForm.get('hotelDetails.contactPhoneNumber')?.invalid && hotelPricingForm.get('hotelDetails.contactPhoneNumber')?.touched }">
                      <app-phone-country-input formControlName="phoneNumber"></app-phone-country-input>
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="input-container">
                    <label for class="label">Contact Email*</label>
                    <div
                      [ngClass]="{ 'invalid-input': hotelPricingForm.get('hotelDetails.contactEmail')?.invalid && hotelPricingForm.get('hotelDetails.contactEmail')?.touched }">
                      <input class="input input-text" placeholder="Email Address" formControlName="contactEmail" />
                    </div>
                  </div>

                </div>

              </div>
            </div>
            <div class="dashed-line mt-2"></div>
            <!-- Room and Pricing -->
            <div>
              <div class="ion-padding-horizontal py-1 bg-light-gray d-flex justify-content-between">
                <ion-title class="dark-title-sm ion-no-padding">Room Details And Pricing</ion-title>
                <div>
                  <div class="currency-container">
                    <label class="label">Currency
                      <select class="input" name="" id="" formControlName="currency">
                        <option value="INR">INR</option>
                        <option value="USD">USD</option>
                        <option value="EURO">EURO</option>
                        <option value="SGD">SGD</option>
                        <option value="THB">THB</option>
                      </select>
                    </label>
                  </div>
                </div>
              </div>
              <ng-container formArrayName="roomDetailsAndPricing">
                <ng-container *ngFor="let pricingGroup of getRoomAndPricingFormArray().controls; index as pricingIndex"
                  [formGroupName]="pricingIndex">
                  <div class="form-containesr ion-padding-horizontal toggle-visibility">
                    <div>
                      <div class="row">
                        <!-- Room Category -->
                        <div class="col-3 date-time-width">
                          <div class="input-container">
                            <label class="label">Room Category *</label>
                            <div
                              [ngClass]="{ 'invalid-input': hotelPricingForm.get('roomDetailsAndPricing.0.roomType')?.invalid && hotelPricingForm.get('roomDetailsAndPricing.0.roomType')?.touched }">
                              <app-dropdown-select [dropdownValues]="roomCategory"
                                formControlName="roomType"></app-dropdown-select>
                            </div>
                          </div>
                        </div>

                        <!-- Near By Place -->
                        <div class="col-3" [ngStyle]="{ 'display': pricingIndex === 0 ? 'block' : 'none' }">
                          <div class="input-container">
                            <label class="label">Near By Place</label>
                            <div>
                              <input class="input-text input" type="text" placeholder="Near By Place"
                                formControlName="nearByPlace">
                            </div>
                          </div>
                        </div>


                        <!-- Meal Plan -->
                        <div class="col-3 date-time-width">
                          <div class="input-container">
                            <label for="" class="label">Meals Plan</label>
                            <div>
                              <app-multi-select-dropdown [dropdownItems]="meals"
                                formControlName="mealPlans"></app-multi-select-dropdown>
                              <!-- <app-multi-select-custom-input-dropdown [dropdownItems]="meals"  formControlName="mealPlans"></app-multi-select-custom-input-dropdown> -->
                            </div>
                          </div>
                        </div>

                        <!-- Facilities -->
                        <div class="col-3 date-time-width">
                          <div class="input-container">
                            <label class="label">Facilities</label>
                            <div>
                              <app-multi-select-custom-input-dropdown [dropdownItems]="facilitiesOptions"
                                formControlName="facilities"></app-multi-select-custom-input-dropdown>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Pricing Table -->
                    <div class="mt-1 package-main-container">
                      <div class="package-title-container">
                        <div class="d-flex justify-content-between align-items-center">
                          <!-- Title or additional buttons can go here if needed -->
                        </div>
                      </div>

                      <!-- Package Table Container -->
                      <div class="pricing-table-container">
                        <table class="pricing-table pax-table">
                          <thead>
                            <tr>
                              <th rowspan="2" style="width: 90px;">Pax Count</th>
                              <th colspan="3">Occupancy</th>
                              <th colspan="2">Child Cost</th>
                              <th colspan="2">Price Validity</th>
                              <th rowspan="2" style="width: 50px;"></th>
                            </tr>
                            <tr>
                              <!-- Occupancy -->
                              <th style="width: 90px;">SGL</th>
                              <th style="width: 90px;">DBL</th>
                              <th style="width: 90px;">TRL</th>

                              <!-- Child Cost -->
                              <th style="width: 90px;">With Bed</th>
                              <th style="width: 90px;">Without Bed</th>

                              <!-- Price Validity -->
                              <th style="width: 120px;">Start Date</th>
                              <th style="width: 120px;">End Date</th>
                            </tr>
                          </thead>
                          <tbody>
                            <ng-container formArrayName="occupancyPricings">
                              <tr
                                *ngFor="let occupanyGroup of getOccupancyPricingFormArray(pricingIndex).controls; index as occupancyIndex"
                                [formGroupName]="occupancyIndex">
                                <!-- Pax Count -->
                                <td>
                                  <div class="pax-container" formGroupName="paxRange">
                                    <div class="input-container">
                                      <div
                                        [ngClass]="{ 'invalid-input': hotelPricingForm.get('roomDetailsAndPricing.' + pricingIndex + '.occupancyPricings.' + occupancyIndex + '.paxRange.minRange')?.invalid &&
                                    hotelPricingForm.get('roomDetailsAndPricing.' + pricingIndex + '.occupancyPricings.' + occupancyIndex + '.paxRange.minRange')?.touched }">
                                        <input appNumbersOnly class="input pax-input" placeholder="0"
                                          formControlName="minRange" />
                                      </div>
                                    </div>
                                    <label class="mx-1">-</label>
                                    <div class="input-container">
                                      <div
                                        [ngClass]="{ 'invalid-input': hotelPricingForm.get('roomDetailsAndPricing.' + pricingIndex + '.occupancyPricings.' + occupancyIndex + '.paxRange.maxRange')?.invalid &&
                                    hotelPricingForm.get('roomDetailsAndPricing.' + pricingIndex + '.occupancyPricings.' + occupancyIndex + '.paxRange.maxRange')?.touched }">
                                        <input appNumbersOnly class="input pax-input" placeholder="0"
                                          formControlName="maxRange"
                                          (blur)="maxRangeChanged($event, pricingIndex, occupancyIndex)" />
                                      </div>
                                    </div>
                                  </div>
                                </td>

                                <!-- Occupancy -->
                                <ng-container formGroupName="occupancy">
                                  <td>
                                    <div class="input-container">
                                      <div
                                        [ngClass]="{ 'invalid-input': hotelPricingForm.get('roomDetailsAndPricing.' + pricingIndex + '.occupancyPricings.' + occupancyIndex + '.occupancy.sgl')?.invalid &&
                                    hotelPricingForm.get('roomDetailsAndPricing.' + pricingIndex + '.occupancyPricings.' + occupancyIndex + '.occupancy.sgl')?.touched }">
                                        <input appNumbersOnly class="input" placeholder="0" formControlName="sgl" />
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="input-container">
                                      <div
                                        [ngClass]="{ 'invalid-input': hotelPricingForm.get('roomDetailsAndPricing.' + pricingIndex + '.occupancyPricings.' + occupancyIndex + '.occupancy.dbl')?.invalid &&
                                    hotelPricingForm.get('roomDetailsAndPricing.' + pricingIndex + '.occupancyPricings.' + occupancyIndex + '.occupancy.dbl')?.touched }">
                                        <input appNumbersOnly class="input" placeholder="0" formControlName="dbl" />
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="input-container">
                                      <div
                                        [ngClass]="{ 'invalid-input': hotelPricingForm.get('roomDetailsAndPricing.' + pricingIndex + '.occupancyPricings.' + occupancyIndex + '.occupancy.tpl')?.invalid &&
                                    hotelPricingForm.get('roomDetailsAndPricing.' + pricingIndex + '.occupancyPricings.' + occupancyIndex + '.occupancy.tpl')?.touched }">
                                        <input appNumbersOnly class="input" placeholder="0" formControlName="tpl" />
                                      </div>
                                    </div>
                                  </td>
                                </ng-container>

                                <!-- Child Cost -->
                                <ng-container formGroupName="childCost">
                                  <td>
                                    <div class="input-container">
                                      <div
                                        [ngClass]="{ 'invalid-input': hotelPricingForm.get('roomDetailsAndPricing.' + pricingIndex + '.occupancyPricings.' + occupancyIndex + '.childCost.withBed')?.invalid &&
                                    hotelPricingForm.get('roomDetailsAndPricing.' + pricingIndex + '.occupancyPricings.' + occupancyIndex + '.childCost.withBed')?.touched }">
                                        <input appNumbersOnly class="input" placeholder="0" formControlName="withBed" />
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="input-container">
                                      <div
                                        [ngClass]="{ 'invalid-input': hotelPricingForm.get('roomDetailsAndPricing.' + pricingIndex + '.occupancyPricings.' + occupancyIndex + '.childCost.withoutBed')?.invalid &&
                                    hotelPricingForm.get('roomDetailsAndPricing.' + pricingIndex + '.occupancyPricings.' + occupancyIndex + '.childCost.withoutBed')?.touched }">
                                        <input appNumbersOnly class="input" placeholder="0"
                                          formControlName="withoutBed" />
                                      </div>
                                    </div>
                                  </td>
                                </ng-container>

                                <!-- Price Validity -->
                                <ng-container formGroupName="priceValidity">
                                  <td>
                                    <div class="input-container">
                                      <div
                                        [ngClass]="{ 'invalid-input': hotelPricingForm.get('roomDetailsAndPricing.' + pricingIndex + '.occupancyPricings.' + occupancyIndex + '.priceValidity.startDate')?.invalid &&
                                    hotelPricingForm.get('roomDetailsAndPricing.' + pricingIndex + '.occupancyPricings.' + occupancyIndex + '.priceValidity.startDate')?.touched }">
                                        <input type="date" class="input" formControlName="startDate"
                                          [max]="todayDate" />
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="input-container">
                                      <div
                                        [ngClass]="{ 'invalid-input': hotelPricingForm.get('roomDetailsAndPricing.' + pricingIndex + '.occupancyPricings.' + occupancyIndex + '.priceValidity.endDate')?.invalid &&
                                    hotelPricingForm.get('roomDetailsAndPricing.' + pricingIndex + '.occupancyPricings.' + occupancyIndex + '.priceValidity.endDate')?.touched }">
                                        <input type="date" class="input" formControlName="endDate"
                                          [min]="startDateValue" />
                                      </div>
                                    </div>
                                  </td>
                                </ng-container>

                                <!-- Remove Button -->
                                <td>
                                  <ion-button fill="clear" color="danger"
                                    (click)="removeOccupancyPricingFormGroup(pricingIndex,occupancyIndex)"
                                    [disabled]="getOccupancyPricingFormArray(pricingIndex).length <= 1">
                                    <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
                                  </ion-button>
                                </td>
                              </tr>
                            </ng-container>
                          </tbody>
                        </table>
                      </div>

                      <!-- Price Validity and Action Buttons -->
                      <div class="pricing-section-footer col-12">
                        <div class="d-flex align-items-center justify-content-end py-2 col-12">
                          <!-- Action Buttons Container -->
                          <div class="col-3 d-flex justify-content-end">
                            <!-- Add Pax -->
                            <ion-button class="sm-clear-btn" fill="clear" size="small"
                              (click)="addOccupancyPricing(pricingIndex)">
                              <ion-icon name="add-outline"></ion-icon> Add Pax
                            </ion-button>

                            <!-- Clear All Pax -->
                            <ion-button class="sm-clear-btn" fill="clear" size="small" color="danger"
                              (click)="clearAllOccupancies(pricingIndex)">
                              <ion-icon name="close-outline"></ion-icon> Clear All Pax
                            </ion-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- room & Pricing -->
                  <div class="d-flex justify-content-end">
                    <!-- Add Room & Pricing Button -->
                    <ion-button class="sm-clear-btn" fill="clear" size="small" (click)="addRoomAndPrcingFormGroup()">
                      <ion-icon name="add-outline"></ion-icon> Add Room & Pricing
                    </ion-button>

                    <!-- Remove Section Button (Visible only if more than one section) -->
                    <ion-button class="sm-clear-btn" fill="clear" size="small" color="danger"
                      (click)="removeRoomAndPricingFormGroup(pricingIndex)"
                      *ngIf="getRoomAndPricingFormArray().length > 1">
                      <ion-icon name="trash-outline"></ion-icon> Remove Section
                    </ion-button>
                  </div>
                </ng-container>
              </ng-container>
            </div>
            <div class="dashed-line mt-2"></div>
            <!-- Notes -->
            <div class="itinerary-model-content">
              <div class="ion-no-padding mb-1">
                <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Notes </ion-title>
              </div>

              <div class="form-container ion-padding-horizontal">
                <div class="row">
                  <div class="col">
                    <div class="input-container">
                      <app-text-formatting-input formControlName="notes"></app-text-formatting-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="dashed-line"></div>
            </div>
          </div>
        </form>

      </div>
    </div>
  </div>
</ion-content>